export default __webpack_public_path__ + "static/media/icon-vote.0d4f914c.svg";